var ajaxPromise,
	pathArray = location.href.split('/'),
	protocol = pathArray[0],
	host = pathArray[2],
    ajax_url = protocol + '//' + host + '/wp-admin/admin-ajax.php';

function housing_contacts(town) {
    $('#loading').addClass('active');
    var result;
    ajaxPromise = $.ajax({
        type: 'POST',
        url: ajax_url,
        dataType: 'json',
        data: ({
            'action': 'ajax_housingcontact',
            'town': town,
        }),
        success: function (data) {
            result = data.html;  
        }
    });
    $.when(ajaxPromise).done(function () {
        $('.m__housingContacts__contact').html(result);
        $('#loading').removeClass('active'); 
		$('[data-slick]').slick();
		loadBackground(); // eslint-disable-line
    });
}

$(document).on("change", 'select.contact-town', function(e) {
    e.preventDefault(); 
    var town = $(this).find(':selected').data('id');
    housing_contacts(town);
});